import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

export enum TagColor {
  Blue = 'blue',
  Purple = 'purple',
  Green = 'green',
  Gray = 'gray',
}

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent implements OnInit {
  @Input()
  label = '';

  @Input()
  icon = '';

  @Input()
  color: TagColor = TagColor.Blue;

  constructor() {}

  ngOnInit(): void {}
}
